'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002469 from "./presto.-Two-Factor-Auth-View$$anon$69.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002471 from "./presto.-Two-Factor-Auth-View$$anon$71.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002473 from "./presto.-Two-Factor-Auth-View$$anon$73.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002475 from "./presto.-Two-Factor-Auth-View$$anon$75.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$68() {
  this.bGi = null;
  this.bGa = null;
  this.bGb = false;
  this.bGj = null;
  this.bGk = false;
  this.bGn = null;
  this.bGg = null;
  this.bGh = false;
  this.bGc = null;
  this.bGd = false;
  this.bGe = null;
  this.bGf = false;
  this.bGl = false;
  this.bGm = false;
  this.bGi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bGn = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$68 as $c_Lpresto_TwoFactorAuthView$$anon$68 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$68.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$68;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$68() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$68 as $h_Lpresto_TwoFactorAuthView$$anon$68 };
$h_Lpresto_TwoFactorAuthView$$anon$68.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bGi;
});
$p.L = (function() {
  if ((!this.bGb)) {
    this.bGa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bGb = true;
  }
  return this.bGa;
});
$p.O = (function() {
  if ((!this.bGk)) {
    this.bGj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bGk = true;
  }
  return this.bGj;
});
$p.E = (function() {
  return this.bGn;
});
$p.t = (function() {
  if ((!this.bGh)) {
    this.bGg = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bGh = true;
  }
  return this.bGg;
});
$p.M = (function() {
  if ((!this.bGd)) {
    this.bGc = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002469.$c_Lpresto_TwoFactorAuthView$$anon$69(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002471.$c_Lpresto_TwoFactorAuthView$$anon$71())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002473.$c_Lpresto_TwoFactorAuthView$$anon$73())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bGd = true;
  }
  return this.bGc;
});
$p.Q = (function() {
  if ((!this.bGf)) {
    this.bGe = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002475.$c_Lpresto_TwoFactorAuthView$$anon$75();
    this.bGf = true;
  }
  return this.bGe;
});
$p.w = (function() {
  if ((!this.bGm)) {
    this.bGl = false;
    this.bGm = true;
  }
  return this.bGl;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee800) => ((p) => \u03b4scrutinee800.z3(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$68 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$68, "presto.TwoFactorAuthView$$anon$68", ({
  T7: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$68 as $d_Lpresto_TwoFactorAuthView$$anon$68 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$68.js.map
